import { SoldProductItem } from '../../hooks';

export type FilterType = 'department' | 'index' | 'subIndex';

export const filterProductsBySearch = (products: SoldProductItem[], inputString: string): SoldProductItem[] => {
  if (!inputString) return products;

  const lowercasedInput = inputString.toLowerCase().trim();
  return products.filter((item) => {
    const { productName, productId } = item;
    return (
      productName.toLowerCase().includes(lowercasedInput) ||
      productId.toString().toLowerCase().includes(lowercasedInput)
    );
  });
};

export const getIsItemFilterEnabled = (
  items: SoldProductItem[],
  type: FilterType,
  value: string,
  currentDepartments: string[],
  currentIndexes: string[],
  currentSubIndexes: string[],
) => {
  if (!items) return true;

  return items.some((item) => {
    switch (type) {
      case 'department':
        return (
          item.departmentName === value &&
          (currentIndexes.length === 0 || currentIndexes.includes(item.index)) &&
          (currentSubIndexes.length === 0 || currentSubIndexes.includes(item.subIndex))
        );
      case 'index':
        return (
          item.index === value &&
          (currentDepartments.length === 0 || currentDepartments.includes(item.departmentName)) &&
          (currentSubIndexes.length === 0 || currentSubIndexes.includes(item.subIndex))
        );
      case 'subIndex':
        return (
          item.subIndex === value &&
          (currentDepartments.length === 0 || currentDepartments.includes(item.departmentName)) &&
          (currentIndexes.length === 0 || currentIndexes.includes(item.index))
        );
      default:
        return true;
    }
  });
};
